import { InvestorRemittanceSplit } from '@willow/graphql-iso/src/app';

export function formatInterestSplit(split: InvestorRemittanceSplit | undefined) {
  if (!split) {
    return '';
  }
  if (split.investor === 100) {
    return '100% to investor';
  }
  if (split.servicer === 100) {
    return '100% to servicer';
  }
  return '50/50 split';
}
